import {
  FormControl,
  InputLabel,
  MenuItem,
  Select,
  SelectChangeEvent,
} from '@mui/material'

import useUrlParams from '@/hooks/useUrlParams'
import removeNullishValues from '@/utils/removeNullishValues'

import { SearchToolbarProps } from '../SearchToolbar'

export const SortBySelector = (props: SearchToolbarProps) => {
  const [searchParams, setSearchParams] = useUrlParams()
  const { sortBy = props.defaultSort ?? 'id' } = searchParams

  const onSort = (e: SelectChangeEvent) => {
    setSearchParams(removeNullishValues({ sortBy: e.target.value }))
  }
  return (
    <FormControl>
      <InputLabel id="sort-by">Sort by</InputLabel>
      <Select label="Age" labelId="sort-by" value={sortBy} onChange={onSort}>
        {props?.sortOptions?.map(({ text, value }) => (
          <MenuItem key={value} value={value}>
            {text}
          </MenuItem>
        ))}
      </Select>
    </FormControl>
  )
}
